import { useMutateMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { NewAssortmentPost } from '@retail/member-config/types';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface AssortmentProps extends QueryOptions {
  dataOwnerId: number;
}

export function useCreateAssortment({ dataOwnerId, ...queryOptions }: AssortmentProps) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, NewAssortmentPost>({
    method: 'POST',
    url: () =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.assortmentConfig.dataOwners.dataOwner.assortment.getFullLinkPath({
          dataOwnerId,
        }),
      }),
    token,
    ...queryOptions,
  });
}

export const useDeleteAssortment = (queryOptions: QueryOptions = {}) => {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void>({
    url: (assortmentId: number) =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.assortmentConfig.assortments.assortment.getFullLinkPath({ assortmentId }),
      }),
    method: 'DELETE',
    token,
    ...queryOptions,
  });
};
